import React from "react";

export interface IUserContentBannerProps {
  firstName?: string;
  lastName?: string;
  district?: string;
  loading?: boolean;
}

export const UserContentBanner: React.FC<IUserContentBannerProps> = ({
  firstName,
  lastName,
  district,
  loading,
}) => {
  return (
    <div className="w-full bg-primary-color px-8 py-3 shadow-sm">
      {loading ? (
        <div className="flex items-center animate-pulse">
          <div className="h-4 w-64 rounded bg-white/30" />
        </div>
      ) : (
        <h4 className="text-base text-white tracking-wide">
          <span className="font-semibold">Authoring For:</span>{" "}
          {`${firstName ?? ""} ${lastName ?? ""}`.trim()}
          {district ? ` (${district})` : ""}
        </h4>
      )}
    </div>
  );
};
